import * as React from "react";
import { GetPage, StoredProcedure, dbQueries } from "duck";
import AutoComplete from "../base";
import { AutoCompleteProps } from "../base/AutoComplete";

const Procedures: React.FC<Omit<
  AutoCompleteProps<StoredProcedure, true>,
  "getPage"
>> = props => {
  const getPage = React.useCallback<GetPage<StoredProcedure>>(
    (_, variables) => dbQueries.loadProcedures(variables),
    []
  );

  return <AutoComplete<any, true> isMulti getPage={getPage} {...props} />;
};

export default Procedures;
